// Version : 0.0.1
// Author : NANDHAKUMAR
// LastEdit : NANDHAKUMAR
// Last Add : 'UNSED IMPORTS AND VARIABLES REMOVED'
// Modified Date : 04-08-2025
/* eslint-disable import/no-anonymous-default-export */
import AutoLoanIndexDisbursementTypes from './auto-loan-index-disbusement.types';
import { docodeHexResponse } from '../../../_common/common.utils';

const INITIAL_STATE = {
	// Fetch Particular Auto Loan Index Details
	getParticularAutoLoanIndexDetailsResponse: null,
	getParticularAutoLoanIndexDetailsArr: [],
	// HDFC Create Individual QR Code
	addHFDCCreateIndividualQRCodeResp: null,
	addHFDCCreateIndividualQRCodeArr: [],
	// Group Wise Auto Loan List
	groupWiseAutoLoanIndexListResp: null,
	groupWiseAutoLoanIndexListArray: [],
	// Add Auto Loan Disbursement
	addAutoLoanIndexDisbursementResp: null,
	// Get Auto Loan Index Schedule
	getAutoLoanPaidScheduleResp: null,
	getAutoLoanPaidScheduleArr: [],
	// Delete Particular Auto Loan Index
	deleteParticularAutoLoanIndexResp: null,
};

export default (state = INITIAL_STATE, action: { type: any; payload: any }) => {
	switch (action.type) {
		/*********** FETCH PARTICULAR LOAN INDEX START ************************ */
		case AutoLoanIndexDisbursementTypes.FETCH_PARTICULAR_AUTO_LOAN_INDEX_DETAILS_SUCCESS:
			return {
				...state,
				getParticularAutoLoanIndexDetailsResponse: action.payload,
				getParticularAutoLoanIndexDetailsArr: docodeHexResponse(
					action.payload,
					'FetchParticularAutoLoanIndexDetails',
				),
			};

		case AutoLoanIndexDisbursementTypes.FETCH_PARTICULAR_AUTO_LOAN_INDEX_DETAILS_FAILURE:
			return { ...state, getParticularAutoLoanIndexDetailsResponse: action.payload };

		case AutoLoanIndexDisbursementTypes.FETCH_PARTICULAR_AUTO_LOAN_INDEX_DETAILS_RESPONSE_CHANGED:
			return { ...state, getParticularAutoLoanIndexDetailsResponse: null };
		/*********** FETCH PARTICULAR LOAN INDEX END ************************ */

		/*********** HDFC CREATE INDIVIDUAL QRCODE START ************************ */
		case AutoLoanIndexDisbursementTypes.HDFC_CREATE_INDIVIDUAL_QRCODE_SUCCESS:
			return {
				...state,
				addHFDCCreateIndividualQRCodeResp: action.payload,
				addHFDCCreateIndividualQRCodeArr: action.payload,
			};
		case AutoLoanIndexDisbursementTypes.HDFC_CREATE_INDIVIDUAL_QRCODE_FAILURE:
			return { ...state, addHFDCCreateIndividualQRCodeResp: action.payload };
		case AutoLoanIndexDisbursementTypes.HDFC_CREATE_INDIVIDUAL_QRCODE_RESPONSE_CHANGED:
			return { ...state, addHFDCCreateIndividualQRCodeResp: null };
		/*********** HDFC CREATE INDIVIDUAL QRCODE END ************************ */

		/*********** GROUP WISE AUTO LOAN LIST START  ************************ */
		case AutoLoanIndexDisbursementTypes.GROUP_WISE_AUTO_LOAN_LIST_SUCCESS:
			return {
				...state,
				groupWiseAutoLoanIndexListResp: action.payload,
				groupWiseAutoLoanIndexListArray: docodeHexResponse(
					action.payload,
					'FetchAllAutoLoanIndexListKey',
				),
			};

		case AutoLoanIndexDisbursementTypes.GROUP_WISE_AUTO_LOAN_LIST_FAILURE:
			return { ...state, groupWiseAutoLoanIndexListResp: action.payload };

		case AutoLoanIndexDisbursementTypes.GROUP_WISE_AUTO_LOAN_LIST_RESPONSE_CHANGED:
			return { ...state, groupWiseAutoLoanIndexListResp: null };
		/*********** GROUP WISE AUTO LOAN LIST END  ************************ */

		/***************** GET AUTO LOAN INDEX DISURSENENT START ***********************/
		case AutoLoanIndexDisbursementTypes.ADD_AUTO_LOAN_INDEX_DISBURSEMENT_SUCCESS:
			return {
				...state,
				addAutoLoanIndexDisbursementResp: action.payload,
			};

		case AutoLoanIndexDisbursementTypes.ADD_AUTO_LOAN_INDEX_DISBURSEMENT_RESPONSE_CHANGED:
			return { ...state, addAutoLoanIndexDisbursementResp: null };

		case AutoLoanIndexDisbursementTypes.ADD_AUTO_LOAN_INDEX_DISBURSEMENT_FAILURE:
			return {
				...state,
				addAutoLoanIndexDisbursementResp: action.payload,
			};

		/*****************  GET  AUTO LOAN INDEX DISURSENENT END ***********************/

		/***************** GET AUTO LOAN INDEX DISURSENENT START ***********************/
		case AutoLoanIndexDisbursementTypes.GET_AUTO_LOAN_INDEX_SCHEDULE_SUCCESS:
			return {
				...state,
				getAutoLoanPaidScheduleResp: action.payload,
				getAutoLoanPaidScheduleArr: docodeHexResponse(
					action.payload,
					'getAutoLoanScheduleKey',
				),
			};

		case AutoLoanIndexDisbursementTypes.GET_AUTO_LOAN_INDEX_SCHEDULE_RESPONSE_CHANGED:
			return { ...state, getAutoLoanPaidScheduleResp: null };

		case AutoLoanIndexDisbursementTypes.GET_AUTO_LOAN_INDEX_SCHEDULE_FAILURE:
			return {
				...state,
				getAutoLoanPaidScheduleResp: action.payload,
			};

		/***************** GET AUTO LOAN INDEX DISURSENENT END ***********************/

		/***************** DELETE PARTICULAR AUTO LOAN INDEX START ***********************/
		case AutoLoanIndexDisbursementTypes.DELETE_PARTICULAR_AUTO_LOAN_INDEX_SUCCESS:
			return {
				...state,
				deleteParticularAutoLoanIndexResp: action.payload,
			};

		case AutoLoanIndexDisbursementTypes.DELETE_PARTICULAR_AUTO_LOAN_INDEX_RESPONSE_CHANGED:
			return { ...state, deleteParticularAutoLoanIndexResp: null };

		case AutoLoanIndexDisbursementTypes.DELETE_PARTICULAR_AUTO_LOAN_INDEX_FAILURE:
			return {
				...state,
				deleteParticularAutoLoanIndexResp: action.payload,
			};

		/***************** DELETE PARTICULAR  AUTO LOAN INDEX  END ***********************/

		default:
			return state;
	}
};
